// 3rd party
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css']
})
export class ConfirmDialogComponent {

  public buttonCancel: string = 'CANCELAR';
  public buttonOk: string = 'OK';
  public message: string;
  public title: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/confirm-dialog/confirm-dialog.component.ts